import { makeStyles } from '@mui/styles';

const useNavButtonStyle = makeStyles({
  root: {
    fontSize: 'max(1.8vw, 20px) !important',
    fontFamily: 'Lato !important',
  },
  hovered: {
    fontSize: 'max(1.8vw, 20px) !important',
    color: '#8CB4FF',
    cursor: 'pointer!important',
    fontFamily: 'Lato !important',
  },
});

export default useNavButtonStyle;
